'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.symbol.has-instance.js
// module id = 724
// module chunks = 13